// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1qIaX","row":"ProcedureTreatmentSummary_row__1jQt-"};